import request from '@/utils/request'

// 提交订单（市价/限价）
export function placeOrder(data) {
  return request({ url: '/ftx/trade/order', method: 'post', data })
}

// 平仓
export function closePosition(data) {
  return request({ url: '/ftx/trade/close', method: 'post', data })
}

// 取消挂单
export function cancelPendingOrder(data) {
  return request({ url: '/ftx/trade/cancel', method: 'post', data })
}

// 修改止损止盈
export function updateSltp(data) {
  return request({ url: '/ftx/trade/sltp', method: 'put', data })
}

// 获取当前持仓
export function getPositions() {
  return request({ url: '/ftx/trade/positions', method: 'get' })
}

// 获取挂单列表
export function getPendingOrders() {
  return request({ url: '/ftx/trade/pending', method: 'get' })
}

// 获取交易历史
export function getTradeHistory(params) {
  return request({ url: '/ftx/trade/history', method: 'get', params })
}

// 获取交易汇总
export function getTradeSummary() {
  return request({ url: '/ftx/trade/summary', method: 'get' })
}

// 获取保证金水平
export function getMarginLevel() {
  return request({ url: '/ftx/trade/margin-level', method: 'get' })
}
